(function () {
  /**
   * iOS Safari often ignores the HTML autoplay attribute; muted + playsInline + play() is required.
   */
  function wireMutedAutoplay(video) {
    if (!(video instanceof HTMLVideoElement) || video.dataset.autoplayWired === 'true') return;
    if (!video.autoplay && !video.hasAttribute('autoplay')) return;

    video.dataset.autoplayWired = 'true';
    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute('muted', '');
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.controls = false;

    var ensurePlaying = function () {
      if (video.paused) {
        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {});
        }
      }
    };

    ensurePlaying();
    video.addEventListener('loadeddata', ensurePlaying);
    video.addEventListener('canplay', ensurePlaying);
    video.addEventListener('pause', ensurePlaying);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) ensurePlaying();
    });
  }

  function init(root) {
    (root || document).querySelectorAll('video.alleras-home-ugc__video[autoplay]').forEach(wireMutedAutoplay);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
